import React from 'react';
import MiCompAPI from '../../../util/api';
import { withRouter } from 'react-router-dom';
import { Layout, Form, Menu, Row, Col, Empty, Spin, message } from 'antd';
import img from '../../../assets/img/Illustratiion@3x.png';
import InviteForm from './InviteForm';
import UserForm from './UserForm';
import Footer from '../../Layout/Footer';

const {
  Header, Content,
} = Layout;
let add = false;
class InviteLaunchPad extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validationStatus: null,
      formLoading: true,
    }
   
    if (this.props.type === "broker") {
      this.signUpForm = Form.create()(InviteForm);
      this.InvitationUrl = "validateBrokerInvitation";
      this.postDataUrl = "ConfirmBroker"
    }
    else if (this.props.type === "user") {
      this.signUpForm = Form.create()(UserForm);
      this.InvitationUrl = "GetUserDetails_By_InvitationId";
      this.postDataUrl = "SaveUser"
    }
    else if (this.props.type === 'carrier') {
      this.signUpForm = Form.create()(InviteForm);
      this.InvitationUrl = "validateClientInvitation";
      this.postDataUrl = "ConfirmClientUser"
    }
    else if (this.props.type === 'agency') {
      this.signUpForm = Form.create()(InviteForm);
      this.InvitationUrl = "validateAgencyInvitation";
      this.postDataUrl = "ConfirmAgencyAdmin"
    }
    else if (this.props.type=== 'member') {
      this.signUpForm = Form.create()(InviteForm);
      this.InvitationUrl = "GetMemberbyId";
      this.postDataUrl = "RegisterMember"
    }
    else if (this.props.type=== 'members') {
      this.signUpForm = Form.create()(InviteForm);
      this.InvitationUrl = "GetMemberbyId";
      this.postDataUrl = "RegisterMember"
    }
    else if (this.props.type === 'login') {
      this.InvitationUrl = "createMemberUserbyUserId"   
    }
    
    this.api = new MiCompAPI(null);
  }
  async componentDidMount() {
    if (this.props.forceValidate) {
      this.setState({ validationStatus: "Valid", formLoading: false });
      add = true;
    }
    else {
      let updatedValidationStatus;
      this.api.invoke(this.InvitationUrl + "/" + this.props.id, "get", (data, success) => {
        if (success) {
          if(this.InvitationUrl==='createMemberUserbyUserId')
          window.open("https://micompqa.z13.web.core.windows.net");
          else if (data.statusCode === 404)
            updatedValidationStatus = "Invalid";
          else if (data.statusCode === 400)
            updatedValidationStatus = "Invalid";
          else if (data.statusCode === 500)
            updatedValidationStatus = "Invalid";
          else if (data.statusMessage === "Link is Expired")
            updatedValidationStatus = "Expired";
          else {
            updatedValidationStatus = "Valid";
            this.data = data.data;
          }
        }
        else {
          this.setState({ isLoading: false })
        }
        this.setState({ validationStatus: updatedValidationStatus, formLoading: false });
      });
    }
  }
  handleSignUp = (values) => {
    
    const closeMessage = message.loading("Please wait while we prepare ourselves for you to onboard.", 0);
  
    this.api.invoke(this.postDataUrl, "post", (data, success) => {
    
      if (data.statusCode===200) {
        closeMessage();
        message.success("Registration successful.", 10).then(() => message.success('Redirecting you to login page...', 5)).then(() => window.location.pathname = "");
      }
      else {
        closeMessage();
        message.error(data.statusMessage, 5);
      }
    }, values);
  }
  render() {
    const header = (<Header style={{ backgroundColor: '#f9f9fd', height: '80px', boxShadow: 'rgba(78, 86, 148, 0.35) 0px 0px 3px 3px' }}><div className="logo" style={{    marginTop: '28px'}}/>
      <Menu
        theme="light"
        mode="horizontal"
        defaultSelectedKeys={['2']}
        style={{ lineHeight: '64px', height: '80px', backgroundColor:'#f9f9fd'}}
      >
        {/* <Menu.Item key=""> <span>Home </span></Menu.Item>
        <Menu.Item key="/about"><span>About </span></Menu.Item>
        <Menu.Item key="/help"><span>Help </span></Menu.Item> */}
      </Menu>
    </Header>);
    if (this.state.formLoading) {
      return (<Layout>
        {header}
        <Spin size="large" style={{ backgroundColor: 'white' }} />
      </Layout>)
    }
    else {
      if (this.state.validationStatus === "Invalid") {
        return (<Layout>
          {header}
          <Content style={{ backgroundColor: 'white'}}>

            <div className="mi_main_inv" style={{margin:'80px auto ',width:'850px'}} >

                <Empty
                  style={{ marginTop: "8%" }}
                  description={
                    <span style={{ fontSize: '30px' }}>
                      Uh Oh! We were not able to find any records for you.
                    </span>
                  }
                />
              </div>

          </Content>
        </Layout>
        );
      }
      else if (this.state.validationStatus === "Expired") {
        return (<Layout style={{ backgroundColor: 'white' }}>
          {header}
          <Content style={{ backgroundColor: 'white' }} onClick={() => window.location.pathname = "/register/" + this.props.type}>
           <div style={{margin:'80px auto'}}>
            <div className="mi_main_inv"  style={{borderRadius:'6px',boxShadow:'0px 0px 0px 2px #d9d9d9'}} >
              <div style={{ height: '50vh' }}>
                <Empty
                  style={{ marginTop: "8%" }}
                  description={
                    <span style={{ fontSize: '30px' }}>
                      Your verification link has expired , to register once again and get a new link please click here.
                    </span>
                  }
                />
              </div>
            </div></div>
          </Content>
        </Layout>
        );
      }
      else if (this.state.validationStatus === "Valid") {
        return (
          <Layout style={{ backgroundColor: 'white' }}>
            {header}
            <Content style={{ margin: '50px auto', backgroundColor: 'white' }} >
              <div className="mi_main_inv" style={{borderRadius:'6px'}} >
                <div className="mi_box">
                  <Row span={24}>
                    <Col span={15}>
                      <h4 className="mi_box_h4"><strong>Secure your Account</strong></h4>
                      <p className='mi_title2' style={{ color: 'white' }}>
                        Just a few more details before we welcome you onboard.
                        Select your password and security questions.Security questions help you  to reset your account.                                </p>
                    </Col>
                    <Col span={9}>
                      <img alt="example" style={{ height: '150px', marginTop: '-60px' }} src={img} />
                    </Col>
                  </Row>
                </div>
                {this.data?
                <this.signUpForm type={this.props.type} data={this.data} submitHandler={this.handleSignUp} passwordRequired={!this.props.forceValidate} />
                :""} </div>
            </Content>
            <Footer className="mi_footer>"></Footer>

          </Layout>
        );
      }
      else {
        return <Empty description="page not found" style={{ height: '277px', marginTop: '100px' }}></Empty>
      }
    }
  }
}
let ex = withRouter(InviteLaunchPad);
if (!add)
  ex = InviteLaunchPad;
export default ex;